import LoadingOverlay from "react-loading-overlay";

export function DefaultSuspense() {
  return (
    <LoadingOverlay active={true} spinner text="Sedang Mengambil Data...">
      <div style={{ height: "100vh", width: "100%" }}></div>
    </LoadingOverlay>
  );
}
